import { Helmet } from "react-helmet-async";
import api from "../../../service/api";
import { Card, Container } from "react-bootstrap";
import DynamicTable from "../../../components/version-two-components/DynamicTable";
import { emailLogsTableColumn } from "./Table/emailLogsTableColumn";
import { useCallback, useEffect, useState } from "react";
import { Search } from "./Search";

export const EmailLogs = () => {
    const [tableData, setTableData] = useState([]);
    const [tableMeta, setTableMeta] = useState({});
    const [tableLinks, setTableLinks] = useState({});
    const [searchValue, setSearchValue] = useState({
        subject:"",
        module: "",
        status: "",
        created_at: "",
    });

    const search = (page) => {
        const searcParams = {...searchValue, ...page}
        setSearchValue(searcParams);
        fetchData(searcParams)
    }

    console.log(searchValue)

    const fetchData = useCallback( async (params = {}) => {
        const response = await api.get("tms/email-notification", params);

        setTableData(response.data);
        setTableMeta(response.meta);
        setTableLinks(response.links);
    },[])

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return (
        <>
            <Helmet title="Notifications > Email Logs" />
            <Container fluid >
                <h3 className="mb-3"> Email Logs</h3>
                <Card.Header>
                    <Search
                        searchValue={searchValue}
                        setSearchValue={setSearchValue}
                        search={search}
                    />
                </Card.Header>
                <Card.Body>
                    <DynamicTable
                        dataPagination={{
                            data: tableData,
                            meta: tableMeta,
                            links: tableLinks,
                        }}
                        columns={emailLogsTableColumn}
                        isPaginated
                        api={fetchData}
                    />
                </Card.Body>
            </Container>
        </>
    );
};
